import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ElementsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  p {
    font-size: ${themeStyle.fontSize14};
    font-weight: ${themeStyle.fontBold};
    color: ${themeStyle.varInkMain};
    margin: 0;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0;
    padding: 0;
    list-style-type: none;

    a {
      font-size: ${themeStyle.fontSize14};
      font-weight: ${themeStyle.fontMedium};
      line-height: 22px;
      color: ${themeStyle.varInkMedium};
      transition: color 0.3s;

      &:hover {
        color: ${themeStyle.varInkMain};
      }
    }
  }
`;
